import React, { useEffect, useState } from "react";
import Sidebar from "../../components/Sidebar";
import Loading from "../../components/Loading/loading";
import { useDispatch, useSelector } from "react-redux";
import "./StudentUpdate.css";
import { clearError, getStudent, studentdUpdate } from "../../actions/fileAction";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { STUDENT_UPDATE_RESET } from "../../constants/fileConstant";

const StudentUpdate = () => {
  const dispatch = useDispatch();
  const { error, isUpdated, loading } = useSelector(
    (state) => state.updateStudent
  );
  const {
    error: StudentError,
    student,
    loading: studentLoaging,
  } = useSelector((state) => state.oneStudent);



  const { id } = useParams();
  const navigate = useNavigate();

  const [addFile, setAddFile] = useState(["1"]);
  const [selectedMultiFile, setSelectedMultiFile] = useState([]);

  const [selectedFile, setSelectedFile] = useState({
    name: "",
    image: "",
  });

  const [adhhar, setAdhhar] = useState("");
  const [passport, setPassport] = useState("");

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [country, setCountry] = useState("");
  const [course, setCourse] = useState("");
  const [status, setStatus] = useState("");

  const [studentData, setStudentData] = useState({
    University_Name:'',Team_Name:'',Agent_Name:'',Intake:'',Date_Of_Birth:'',
    Region:'',Application_Id:'',Student_Id:'',Course:'',CO_Received_Date:'',Payment:'',
    Mode_of_Payment:'',Suitability_Interview:'',Credibility_Interview:'',
    CAS_Request_Date:'',Education_Verification:'',Financial_Verification:'',Affidavit:''
  })

const {
  University_Name,Team_Name,Agent_Name,Intake,Date_Of_Birth,
    Region,Application_Id,Student_Id,Course,CO_Received_Date,Payment,
    Mode_of_Payment,Suitability_Interview,Credibility_Interview,
    CAS_Request_Date,Education_Verification,Financial_Verification,Affidavit
} = studentData;




const studentDataChangeHandler = e => {
  setStudentData({...studentData, [e.target.name]: e.target.value})
}

const studentDataSetHandler = (key,value) => {
  setStudentData( prevValues => {
  return { ...prevValues,[key]: value}
})
}

  useEffect(() => {
    setAdhhar(student?.adhaar)
    setPassport(student?.Passport)

    setName(student?.Name)
    setEmail(student?.Email)
    setCountry(student?.Country)
    setCourse(student?.Course)
    setStatus(student?.status)
    setPhone(student?.Phone)

    if(student != null){

      const studentDataArray = Object.entries(student);

      studentDataArray?.forEach(([key,value]) => {
          studentDataSetHandler( key,value)
        });
    }

    // 

  }, [studentLoaging]);

  const dispachFuc = async () => {
    await setSelectedMultiFile([
      ...selectedMultiFile,
      {
        value: selectedFile,
      },
    ]);
  };

  const studentUpdateHandler = async (e) => {
    e.preventDefault();

    //    await dispachFuc();
    if (selectedFile.image !== "" && selectedFile.name !== "") {
      selectedMultiFile.push({ value: selectedFile });
    }

    let data = {
      adhaar: adhhar?.toString(),
      Passport: passport.toString(),
      Name:name, Email:email, Country:country, Course:course, status, Phone:phone,
      University_Name,Team_Name,Agent_Name,Intake,Date_Of_Birth,
      Region,Application_Id,Student_Id,Course,CO_Received_Date,Payment,
      Mode_of_Payment,Suitability_Interview,Credibility_Interview,
      CAS_Request_Date,Education_Verification,Financial_Verification,Affidavit

    };
    const documentsFiles = selectedMultiFile
    // console.log("file", data)

    dispatch(studentdUpdate(id, data, documentsFiles));
  };

  const addFileHandler = (e) => {
    e.preventDefault();
    // addFile.push('1')

    setSelectedMultiFile([
      ...selectedMultiFile,
      {
        value: selectedFile,
      },
    ]);
    // selectedMultiFile.push(selectedFile)

    setAddFile((data) => [...data, "1"]);
  };
  const closeFileHandler = (e) => {
    e.preventDefault();

    if (addFile.length > 1) {
      addFile.pop(); // removes last element from array
      setAddFile([...addFile]); // clone remaining array
    }
  };

  const changeFiledata = (e) => {
    const reader = new FileReader();

    const imgFile = e.target.files[0];
    // console.log(imgFile.size)
    if (imgFile.size > 5 * 1024 * 1024) {
      toast.error("Max file size 5mb accepted.");
    } else {
      reader.onload = () => {
        if (reader.readyState === 2) {
          setSelectedFile({ ...selectedFile, image: reader.result });
        }
      };

      reader.readAsDataURL(e.target.files[0]);
    }
  };

  useEffect(() => {
    if (error) {
      toast.error(error);
      dispatch(clearError());
      // setSelectedMultiFile([])
    }
    if (isUpdated) {
      toast.success("Updated Successfully");
      // if(user?.role==='counsellor'){
      // }else{

      // }
      navigate(-1);
      dispatch({ type: STUDENT_UPDATE_RESET });
      // setSelectedMultiFile([])
    }
    // dispatch(set)
    dispatch(getStudent(id))

    if (StudentError) {
      toast.error(StudentError)
      dispatch(clearError())

    }
  }, [error, isUpdated, dispatch, selectedMultiFile, StudentError]);

  return (
    <div className="dashboardMain">
      <div
        className={
          window.innerWidth > 600 ? "menuContainer show" : "menuContainer hide"
        }
      >
        <Sidebar />
      </div>
      {loading ? (
        <Loading />
      ) : (
        <div className="dashboardContainer">
          {/* <DashboardHeader heading={"Students Application"} /> */}

          <div className="StudentUpdateBox">
            <form action="" onSubmit={studentUpdateHandler}>
              <h3>Update - Student Details </h3>

              

              <div className="updateItemBox">
                <div className="updateInputItem">
                  <p>Name</p>
                  <input
                    type="text"
                    required

                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </div>

                <div className="updateInputItem">
                  <p>Email</p>
                  <input
                    type="text"
                    required

                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
              </div>

              <div className="updateItemBox">
                <div className="updateInputItem">
                  <p>Serial No</p>
                  <input
                    type="text"
                    placeholder="Serial No"
                    value={adhhar}
                    onChange={(e) => setAdhhar(e.target.value)}
                  />
                </div>

                <div className="updateInputItem">
                  <p>Passport Number</p>
                  <input
                    type="text"
                    required
                    placeholder="Passport No"
                    value={passport}
                    onChange={(e) => setPassport(e.target.value)}
                  />
                </div>
              </div>


              <div className="updateItemBox">
                <div className="updateInputItem">
                  <p>Phone no.</p>
                  <input
                    type="text"
                    required

                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                  />
                </div>

                <div className="updateInputItem">
                  <p>Country </p>
                  <input
                    type="text"
                    required

                    value={country}
                    onChange={(e) => setCountry(e.target.value)}
                  />
                </div>
              </div>


             
              <div className="updateItemBox">
                <div className="updateInputItem">
                  <p>University Name</p>
                  <input
                  name="University_Name"
                    type="text"
                    required
                    value={University_Name}
                    onChange={studentDataChangeHandler}
                  />
                </div>

                <div className="updateInputItem">
                  <p>Team Name</p>
                  <input
                  name="Team_Name"
                    type="text"
                    required
                    value={Team_Name}
                    onChange={studentDataChangeHandler}
                  />

                </div>
              </div>

              <div className="updateItemBox">
                <div className="updateInputItem">
                  <p>Agent Name</p>
                  <input
                  name="Agent_Name"
                    type="text"
                    required
                    value={Agent_Name}
                    onChange={studentDataChangeHandler}
                  />
                </div>

                <div className="updateInputItem">
                  <p>Intake</p>
                  <input
                  name="Intake"
                    type="text"
                    required
                    value={Intake}
                    onChange={studentDataChangeHandler}
                  />

                </div>
              </div>


              <div className="updateItemBox">
                <div className="updateInputItem">
                  <p>Date Of Birth</p>
                  <input
                  name="Date_Of_Birth"
                    type="text"
                    required
                    value={Date_Of_Birth}
                    onChange={studentDataChangeHandler}
                  />
                </div>

                <div className="updateInputItem">
                  <p>Region</p>
                  <input
                  name="Region"
                    type="text"
                    required
                    value={Region}
                    onChange={studentDataChangeHandler}
                  />

                </div>
              </div>

              
              <div className="updateItemBox">
                <div className="updateInputItem">
                  <p>Application Id</p>
                  <input
                  name="Application_Id"
                    type="text"
                    required
                    value={Application_Id}
                    onChange={studentDataChangeHandler}
                  />
                </div>

                <div className="updateInputItem">
                  <p>Student Id</p>
                  <input
                  name="Student_Id"
                    type="text"
                    required
                    value={Student_Id}
                    onChange={studentDataChangeHandler}
                  />

                </div>
              </div>

              
              <div className="updateItemBox">
                <div className="updateInputItem">
                  <p>Course</p>
                  <input
                  name="Course"
                    type="text"
                    required
                    value={Course}
                    onChange={studentDataChangeHandler}
                  />
                </div>

                <div className="updateInputItem">
                  <p>CO Received Date</p>
                  <input
                  name="CO_Received_Date"
                    type="text"
                    required
                    value={CO_Received_Date}
                    onChange={studentDataChangeHandler}
                  />

                </div>
              </div>


              <div className="updateItemBox">
                <div className="updateInputItem">
                  <p>Payment</p>
                  <input
                  name="payment"
                    type="text"
                    required
                    value={Payment}
                    onChange={studentDataChangeHandler}
                  />
                </div>

                <div className="updateInputItem">
                  <p>Mode of Payment</p>
                  <input
                  name="Mode_of_Payment"
                    type="text"
                    required
                    value={Mode_of_Payment}
                    onChange={studentDataChangeHandler}
                  />

                </div>
              </div>

              
              <div className="updateItemBox">
                <div className="updateInputItem">
                  <p>Suitability Interview</p>
                  <input
                  name="Suitability_Interview"
                    type="text"
                    required
                    value={Suitability_Interview}
                    onChange={studentDataChangeHandler}
                  />
                </div>

                <div className="updateInputItem">
                  <p>Credibility Interview</p>
                  <input
                  name="Credibility_Interview"
                    type="text"
                    required
                    value={Credibility_Interview}
                    onChange={studentDataChangeHandler}
                  />

                </div>
              </div>



              <div className="updateItemBox">
                <div className="updateInputItem">
                  <p>CAS Request Date</p>
                  <input
                  name="CAS_Request_Date"
                    type="text"
                    required
                    value={CAS_Request_Date}
                    onChange={studentDataChangeHandler}
                  />
                </div>

                <div className="updateInputItem">
                  <p>Education Verification</p>
                  <input
                  name="Education_Verification"
                    type="text"
                    required
                    value={Education_Verification}
                    onChange={studentDataChangeHandler}
                  />

                </div>
              </div>

              <div className="updateItemBox">
                <div className="updateInputItem">
                  <p>Financial Verification</p>
                  <input
                  name="Financial_Verification"
                    type="text"
                    required
                    value={Financial_Verification}
                    onChange={studentDataChangeHandler}
                  />
                </div>

                <div className="updateInputItem">
                  <p>Affidavit</p>
                  <input
                  name="Affidavit"
                    type="text"
                    required
                    value={Affidavit}
                    onChange={studentDataChangeHandler}
                  />

                </div>
              </div>

              <div className="updateItemBox">

                <div className="seletItem">
                  <p>Please Check Status</p>
                  <select name="" id=""
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}>
                    <option value="applied">Applied</option>
                    <option value="inprogress">Inprogress</option>
                    <option value="rejected">Rejected</option>
                    <option value="approved">Approved</option>


                  </select>

                </div>
              </div>




              {/* file upload code */}
              {addFile.map((e, index) => (
                <div className="updateInputItem fileItem">
                  <p> {index + 1} File </p>
                  <input
                    type="text"

                    placeholder="Enter File name"
                    onChange={(e) => {
                      setSelectedFile({
                        ...selectedFile,
                        name: e.target.value,
                      });
                    }}
                  />{" "}
                  <br />
                  <input
                    type="file"
                    accept=".jpg, .jpeg, .png, .docx, .pdf, .doc"
                    className="fileBtn"
                    placeholder="Enter File name"
                    onChange={changeFiledata}
                  />
                  <p>Accepted Only : jpg, jpeg, png, docx, pdf, doc. | max-size : 5mb </p>
                </div>
              ))}

              <div className="ActionBox">
                <button onClick={(e) => addFileHandler(e)} className="addBtn">
                  Add File
                </button>
                <button
                  onClick={(e) => closeFileHandler(e)}
                  className="closeBtn"
                >
                  Close
                </button>
              </div>

              <div className="submitItem">
                <input type="submit" value={"Update"} />
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default StudentUpdate;
